import {ActivatedRoute, CanDeactivate} from '@angular/router';
import { Injectable } from '@angular/core';
import {Observable, Observer} from 'rxjs';
import {LoadEdit} from "../../../app/pages/applicants/edit/state/edit.actions";
import {Store} from "@ngrx/store";
import {Edit} from "../../../app/pages/applicants/edit/state/edit";
import {FuseConfirmationService} from "../../services/confirmation";

export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

    constructor(private _fuseConfirmationService: FuseConfirmationService) {}

    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
        // Allow navigation if the component says that it is OK or it doesn't have a canDeactivate function
        if (!component.canDeactivate || component.canDeactivate()) {
            return true;
        }
        // if there are no pending changes, just allow deactivation; else confirm first
        return Observable.create((observer: Observer<boolean>) => {
            this._fuseConfirmationService.open({
                title  : 'Warning',
                message: 'You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.',
                actions: {
                    confirm: {
                        label: 'OK',
                    }
                }
            }).afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    observer.next(result);
                    observer.complete();
                }
                else{
                    observer.next(false);
                    observer.complete();
                }
            })
        })

    }

}
